module.exports = __webpack_public_path__ + "img/america-5.0adb90e7.png";